'use client';

import * as a from "react";
import p$1 from "../lib/IconBase.es.js";
import e from "../defs/MapPinLine.es.js";
const o = a.forwardRef((n, a$1) => /* @__PURE__ */ a.createElement(p$1, { ref: a$1, ...n, weights: e }));
o.displayName = "MapPinLineIcon";
const p = o;
export {
  p as MapPinLine,
  o as MapPinLineIcon
};
